import type { Landmark } from '../../../data/types';
import type { Ring } from '../../../geo/types';
import { minderbroedersFoundations } from './minderbroeders';
import { cellezustersObstacles } from './cellezustersPlan';
import { prinsenhofObstacles } from './prinsenhofConventsPlan';
import { ursulaObstacles } from './ursulaPlan';
import { oudeNonnenFoundations } from './oudeNonnenPlan';
import { nieuweNonnenFoundations } from './nieuweNonnenPlan';
import { sintMariaFoundations } from './sintMariaPlan';
import { cellebroedersFoundations } from './cellebroedersPlan';
import { hasMagdalenaBarbaraPlan, magdalenaBarbaraFoundations } from './magdalenaBarbaraPlan';
import { sintClaraFoundations } from './sintClaraPlan';
import { sintMargrietFoundations } from './sintMargrietPlan';
import { sintGeertruidFoundations } from './sintGeertruidPlan';
import { sintLucienFoundations } from './sintLucienPlan';
import { kartuizersFoundations } from './kartuizersStructures';
import { lucienerfFoundations } from './lucienerfPlan';
import { sintPieterskapelFoundations } from './sintPieterskapelPlan';
import { paulusConventFoundations } from './paulusbroedersConvent';
import { heiligewegClarissenFoundations } from './heiligewegClarissenPlan';
import { stadhuisFoundations } from './stadhuis/stadhuisPlan';
import { oudeKerkObstacles } from './oudeKerk/oudeKerkObstacles';

type Footing = (landmark: Landmark) => readonly Ring[];

const PLANNED: Readonly<Record<string, Footing>> = {
  'landmark-oude-kerk': oudeKerkObstacles,
  'landmark-oude-stadhuis': stadhuisFoundations,
  'landmark-kartuizerklooster': kartuizersFoundations,
  'landmark-clarissen': heiligewegClarissenFoundations,
  'landmark-lucienerf-carpenter': lucienerfFoundations,
  'landmark-sint-lucien': sintLucienFoundations,
  'landmark-sint-geertruid': sintGeertruidFoundations,
  'landmark-sint-pieterskapel': sintPieterskapelFoundations,
  'landmark-sint-margriet': sintMargrietFoundations,
  'landmark-sint-clara': sintClaraFoundations,
  'landmark-minderbroeders': minderbroedersFoundations,
  'landmark-paulusbroederskapel': paulusConventFoundations,
  'landmark-cellebroeders': cellebroedersFoundations,
  'landmark-sint-maria': sintMariaFoundations,
  'landmark-nieuwe-nonnen': nieuweNonnenFoundations,
  'landmark-oude-nonnen': oudeNonnenFoundations,
  'landmark-sint-ursula': ursulaObstacles,
  'landmark-cellezusters': cellezustersObstacles,
  'landmark-sint-cecilia': prinsenhofObstacles,
  'landmark-sint-catharina': prinsenhofObstacles,
};

/**
 * The rings a landmark's walls stand on: the plan's own buildings where the landmark has one,
 * its traced footprint where it has not. The ground under them sets how far the walls reach down
 * (foundation.ts, footDepth).
 */
export function landmarkFooting(landmark: Landmark): readonly Ring[] {
  if (hasMagdalenaBarbaraPlan(landmark)) return magdalenaBarbaraFoundations(landmark);
  return (PLANNED[landmark.id] ?? (() => [landmark.footprint]))(landmark);
}
